module.exports = __webpack_public_path__ + "img/huangguan.4e85da88.jpg";